import React, { useState } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import EnTetePage from '../../Layout/EnTetePage/EnTetePage';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';

import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Tableau from '../../Tableau/Tableau';

import AddCustomerModal from './AddCustomerModal/AddCustomerModal';
import DeleteCustomerModal from './DeleteCustomerModal/DeleteCustomerModal';

const useStyles = makeStyles()(() => ({
  root: {
    margin: 'auto',
    width: '99%',
    padding: '20px',
  },
}));

export default function Customers() {
  const { classes } = useStyles();
  const { t } = useTranslation('customers');
  const customers = useSelector((state) => state.customers.customers)
    .map((customer) => ({ ...customer }));

  const [customerModalOpen, setCustomerModalOpen] = useState(false);
  const [removeModalOpen, setRemoveModalOpen] = useState(false);
  // La fiche en cours d'édition ou de retrait. Vide = inscription.
  const [selectedCustomer, setSelectedCustomer] = useState({});

  const handleCustomerModalClose = () => {
    setCustomerModalOpen(false);
    setSelectedCustomer({});
  };

  const handleAddCustomerModalOpen = () => {
    setSelectedCustomer({});
    setCustomerModalOpen(true);
  };

  const handleEditCustomerModalOpen = (customer) => {
    setSelectedCustomer(customer);
    setCustomerModalOpen(true);
  };

  const handleRemoveModalOpen = (customer) => {
    setSelectedCustomer(customer);
    setRemoveModalOpen(true);
  };

  const handleRemoveModalClose = () => {
    setRemoveModalOpen(false);
    setSelectedCustomer({});
  };

  return (
    <>
      {/* Les deux fenêtres sont montées à la demande : gardées en place, elles
          rejoueraient les valeurs de la fiche précédente au rendu suivant. */}
      {customerModalOpen && (
        <AddCustomerModal
          display={customerModalOpen}
          handleClose={handleCustomerModalClose}
          customer={selectedCustomer}
        />
      )}
      {removeModalOpen && (
        <DeleteCustomerModal
          display={removeModalOpen}
          handleClose={handleRemoveModalClose}
          customer={selectedCustomer}
        />
      )}
      <Grid container spacing={2} className={classes.root}>
        <Grid item xs={12}>
          <EnTetePage titre={t('customers')} intro={t('intro')} />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            component="label"
            color="secondary"
            onClick={handleAddCustomerModalOpen}
          >
            {t('add_customer.button')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Tableau
            colonnes={[
              { title: t('firstName'), field: 'first_name' },
              { title: t('lastName'), field: 'last_name' },
              { title: t('email'), field: 'email' },
              // `phone`, et non `phone_number` : c'est le nom du champ rendu
              // par l'API (`CustomerSerializer`). La colonne était vide pour
              // tout le monde depuis toujours.
              { title: t('phoneNumber'), field: 'phone' },
              { title: t('language'), field: 'language' },
              { title: t('note'), field: 'note' },
            ]}
            donnees={customers}
            titre={t('customers')}
            actions={[
              {
                icon: () => <EditIcon />,
                tooltip: t('edit_customer.tooltip'),
                onClick: (event, customer) => handleEditCustomerModalOpen(customer),
              },
              {
                icon: () => <PersonAddDisabledIcon />,
                tooltip: t('delete_customer.tooltip'),
                onClick: (event, customer) => handleRemoveModalOpen(customer),
              },
            ]}
          />

        </Grid>

      </Grid>
    </>
  );
}
